import { render, staticRenderFns } from "./SectionContatti.vue?vue&type=template&id=62505751&"
import script from "./SectionContatti.vue?vue&type=script&lang=js&"
export * from "./SectionContatti.vue?vue&type=script&lang=js&"
import style0 from "./SectionContatti.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports